<template>
  <div class="gx-as">
    <!-- <h1 class="gx-main__title">抖店售后</h1> -->

    <!-- 筛选栏 -->
    <div class="gx-as__filter custom-form-wrap">
<!--      <div class="gx-as__fitem">
        <label class="gx-as__flabel">店铺分组</label>
        <multi-select v-model="searchData.group_ids" :options="groupList" placeholder="全部分组" @input="initFilterData" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">店铺名</label>
        <select v-model="searchData.shop_id" class="gx-as__select">
          <option value="">全部</option>
          <option v-for="s in arrShop" :key="s.key" :value="s.val">{{ s.key }}</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">售后类型</label>
        <select v-model="searchData.after_sale_type" class="gx-as__select" @change="changeStatus">
          <option v-for="t in arrAfterSalesType" :key="t.val" :value="t.val">{{ t.text }}</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">退款/仓库类型</label>
        <select v-model="searchData.type" class="gx-as__select" required>
          <option value="" disabled hidden>请选择</option>
          <option v-for="t in typeList" :key="t.val" :value="t.val">{{ t.text }}</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">售后状态</label>
        <select v-model="searchData.after_sale_status" class="gx-as__select" required>
          &lt;!&ndash; <option value="">全部</option> &ndash;&gt;
          <option value="" disabled hidden>请选择</option>
          <option v-for="s in arrStatus" :key="s.val" :value="s.val">{{ s.text }}</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">申请原因</label>
        <select v-model="searchData.apply_reason" class="gx-as__select" required>
          &lt;!&ndash; <option value="">全部</option> &ndash;&gt;
          <option value="" disabled hidden>请选择</option>
          <option v-for="r in arrApplyReason" :key="r" :value="r">{{ r }}</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">商品ID</label>
        <input v-model="searchData.goods_id" class="gx-as__input" placeholder="请输入商品ID" @keyup.enter="getList()" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">售后编号</label>
        <input v-model="searchData.aftersale_id" class="gx-as__input" placeholder="请输入售后编号" @keyup.enter="getList()" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">订单编号</label>
        <input v-model="searchData.order_no" class="gx-as__input" placeholder="请输入订单编号" @keyup.enter="getList()" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">订单物流单号</label>
        <input v-model="searchData.express_no" class="gx-as__input" placeholder="请输入订单物流单号" @keyup.enter="getList()" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">退货物流单号</label>
        <input v-model="searchData.return_logistics_code" class="gx-as__input" placeholder="请输入退货物流单号" @keyup.enter="getList()" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">换货物流单号</label>
        <input v-model="searchData.exchange_logistics_code" class="gx-as__input" placeholder="请输入换货物流单号" @keyup.enter="getList()" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">申请时间</label>
        <input v-model="dateStart" type="datetime-local" class="gx-as__input gx-as__input&#45;&#45;date" @change="syncDate" />
        <span class="gx-as__range-sep">至</span>
        <input v-model="dateEnd" type="datetime-local" class="gx-as__input gx-as__input&#45;&#45;date" @change="syncDate" />
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">临期待处理</label>
        <select v-model="searchData.in_deadline" class="gx-as__select">
          <option value="">全部</option>
          <option :value="1">是</option>
          <option :value="2">否</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">处理不一致</label>
        <select v-model="searchData.diff_deal_state" class="gx-as__select">
          <option value="">全部</option>
          <option :value="0">全部</option>
          <option :value="10">1688同意/抖店拒绝</option>
          <option :value="20">1688拒绝/抖店同意</option>
          <option :value="30">处理一致</option>
        </select>
      </div>
      <div class="gx-as__fitem">
        <label class="gx-as__flabel">1688售后状态</label>
        <select v-model="searchData.alibaba_refund_status" class="gx-as__select">
          <option value="">全部</option>
          <option v-for="s in arrAlibabaRefundStatus" :key="s.val" :value="s.val">{{ s.text }}</option>
        </select>
      </div>-->
      <el-form inline size="mini">
        <el-form-item label="店铺分组：">
          <el-select class="w290" v-model="searchData.group_ids" placeholder="全部分组" clearable
                     multiple collapse-tags filterable @change="initFilterData">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名：">
          <el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable>
            <el-option v-for="item in arrShop" :key="item.key" :label="item.key" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select class="w290" v-model="searchData.after_sale_type" @change="changeStatus" placeholder="请选择" clearable>
            <el-option v-for="item in arrAfterSalesType" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款/仓库类型：">
          <el-select class="w290" v-model="searchData.type" placeholder="请选择" clearable>
            <el-option v-for="item in typeList" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后状态：">
          <el-select class="w290" v-model="searchData.after_sale_status" placeholder="请选择" clearable>
            <el-option v-for="item in arrStatus" :key="item.val" :label="item.text" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请原因：">
          <el-select class="w290" v-model="searchData.apply_reason" placeholder="请选择" clearable filterable>
            <el-option v-for="item in arrApplyReason" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品ID：">
          <el-input class="w290" v-model="searchData.goods_id" placeholder="请输入商品ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="售后编号：">
          <el-input class="w290" v-model="searchData.aftersale_id" placeholder="请输入售后编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单编号：">
          <el-input class="w290" v-model="searchData.order_no" placeholder="请输入订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单物流单号：">
          <el-input class="w290" v-model="searchData.express_no" placeholder="请输入订单物流单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="退货物流单号：">
          <el-input class="w290" v-model="searchData.return_logistics_code" placeholder="请输入退货物流单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="换货物流单号：">
          <el-input class="w290" v-model="searchData.exchange_logistics_code" placeholder="请输入换货物流单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker class="w290"
                          v-model="searchData.search_date"
                          type="datetimerange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="pickerOptions"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="临期待处理：">
          <el-select class="w120" v-model="searchData.in_deadline" placeholder="请选择" clearable>
            <el-option :value="1" label="是"></el-option>
            <el-option :value="2" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理不一致：">
          <el-select class="w290" v-model="searchData.diff_deal_state" placeholder="请选择" clearable>
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="10" label="1688同意/抖店拒绝"></el-option>
            <el-option :value="20" label="1688拒绝/抖店同意"></el-option>
            <el-option :value="30" label="处理一致"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="1688售后状态：">
          <el-select class="w290" v-model="searchData.alibaba_refund_status" placeholder="请选择" clearable>
            <el-option v-for="item in arrAlibabaRefundStatus" :key="item.val" :label="item.text" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" style="margin-left: auto;">
          <button type="button" class="gx-as__filter-btn gx-as__filter-btn--primary" @click="getList()">查询</button>
          <button type="button" class="gx-as__filter-btn" @click="resetSearch">重置</button>
        </el-form-item>

      </el-form>

    </div>

    <!-- 列标题 + 列表 + 分页 -->
    <div class="gx-as__card">
      <!-- 状态 tabs（并入列表面板） -->
      <div class="gx-as__status-tabs">
        <button
          v-for="s in arrTabList"
          :key="s.val"
          class="gx-as__status-tab"
          :class="{ 'gx-as__status-tab--on': searchData.tab_value == s.val }"
          @click="onTabChange(s.val)"
        >{{ s.text }}<span v-if="tabBadgeCount(s) > 0" class="gx-as__status-num">{{ tabBadgeCount(s) }}</span></button>
      </div>

      <!-- 批量操作工具栏 -->
      <div class="gx-as__toolbar">
        <label class="gx-as__checkall">
          <input type="checkbox" :checked="allChecked" :indeterminate.prop="checkListIndeterminate" @change="bindCheckAll($event.target.checked)" />
          <span class="gx-as__checkall-box">
            <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
            <span v-else-if="checkListIndeterminate" class="gx-as__checkall-dash"></span>
          </span>
        </label>
        <div class="gx-as__divider"></div>
        <span class="gx-as__batch-label">共 {{ pageData.total }} 条</span>
        <div class="gx-as__divider"></div>
        <button class="gx-as__btn  gx-as__btn--pink" :disabled="batchOperateSubmitting" @click="bindBatchAftersaleOperate(DD_AFTERSALE_BATCH_HANDLE_REFUND)">{{ batchOperateSubmitting ? '处理中...' : '批量同意退款' }}</button>
        <button class="gx-as__btn gx-as__btn--plain" :disabled="batchOperateSubmitting" @click="bindBatchAftersaleOperate(DD_AFTERSALE_BATCH_HANDLE_RETURN)">{{ batchOperateSubmitting ? '处理中...' : '批量同意退货' }}</button>
      </div>
      <div class="gx-table gx-as__table">
        <table>
          <thead>
            <tr>
              <th style="width: 32px;box-sizing: border-box;"></th>
              <th>商品信息</th>
              <th>金额</th>
              <th>件数</th>
              <th>售后状态</th>
              <th>原因</th>
              <th>1688售后信息</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td>
                <span class="gx-as__check" :class="{ 'gx-as__check--on': checkList.includes(item.id) }" @click="toggleOne(item.id)">
                  <svg v-if="checkList.includes(item.id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </td>
              <!-- 售后信息 -->
              <td>
                <div class=" gx-as__col-info">
                  <div class="gx-as__info-lines">
                    <p class="gx-as__info-line">
                      <span class="gx-as__info-k">抖店单号：</span>
                      <template v-if="item.dd_shop">
                        <span class="gx-as__oid">{{ isHideOrderInfo ? '************' : item.sku_order_id }}</span><i class="gx-as__copy" @click="bindCopy(item.sku_order_id)">⧉</i>
                      </template>
                      <span v-else class="gx-as__shop-deleted">店铺已删除</span>
                    </p>
                    <p class="gx-as__info-line">
                      <span v-if="item.dd_shop" class="gx-as__shop">{{ isHideOrderInfo ? '************' : item.dd_shop.shop_name }}</span>
                      <span v-else class="gx-as__ph">--</span>
                    </p>
                    <p class="gx-as__info-line">
                      <span class="gx-as__info-k">售后单号：</span>
                      <span class="gx-as__oid">{{ dash(item.aftersale_id) }}</span><i class="gx-as__copy" @click="bindCopy(item.aftersale_id)">⧉</i>
                    </p>
                    <p class="gx-as__info-line">
                      <span class="gx-as__info-k">申请时间：</span>
                      <span class="gx-as__info-v">{{ dash(item.apply_time) }}</span>
                    </p>
                  </div>

                  <div class=" gx-as__goods">
                    <div class="gx-as__thumbs">
                      <div class="gx-as__thumb-cell">
                        <span class="gx-as__thumb gx-as__thumb--dd"><img v-if="item.order_product && item.order_product.product_pic" :src="item.order_product.product_pic" alt="" @click="openImg(item.order_product)" /><span v-else>🛍️</span></span>
                        <!-- <span class="gx-as__thumb-label gx-as__thumb-label--dd">抖店</span> -->
                      </div>
                      <!-- <div class="gx-as__thumb-cell" v-if="item.alibaba_aftersale && item.alibaba_aftersale.product && item.alibaba_aftersale.product.img">
                        <span class="gx-as__thumb gx-as__thumb--ali is-link" @click="openAlibabaOfferDetail(item.alibaba_aftersale.product)">
                          <img :src="item.alibaba_aftersale.product.img" alt="" />
                        </span>
                        <span class="gx-as__thumb-label gx-as__thumb-label--ali">1688</span>
                      </div>
                      <div class="gx-as__thumb-cell" v-else>
                        <span class="gx-as__thumb gx-as__thumb--ali gx-as__thumb--empty">--</span>
                        <span class="gx-as__thumb-label gx-as__thumb-label--ali gx-as__thumb-label--off">1688</span>
                      </div> -->
                    </div>
                    <div class="gx-as__con-box">
                      <!-- <p class="gx-as__goods-tags">
                        <span class="gx-as__tag gx-as__tag--red" v-if="item.text_part && item.text_part.aftersale_type_text">{{ item.text_part.aftersale_type_text }}</span>
                        <span v-else class="gx-as__ph">--</span>
                      </p> -->
                      <p class="gx-as__product-title">{{ isHideOrderInfo ? '************' : dash(item.order_product && item.order_product.product_name) }}</p>
                      <!-- <p class="gx-as__ali-name" :class="{ 'gx-as__ph': !aliProductName(item) }">{{ dash(aliProductName(item)) }}</p> -->
                      <p class="gx-as__dim">{{ item.order_product ? dash(item.order_product.spec_value) : '--' }} x {{ item.order_product && item.order_product.item_num != null && item.order_product.item_num !== '' ? item.order_product.item_num : '--' }}</p>
                      <!-- <p class="gx-as__dim gx-as__code-line">
                        商品编码：{{ dash(pickVal(item, ['order_product.outer_sku_id', 'order_product.sku_code', 'order_product.pdd_code'])) }}
                      </p> -->
                      <p class="gx-as__dim gx-as__code-line">
                        商品ID：{{ dash(pickVal(item, ['order_product.goods_id', 'order_product.product_id'])) }}
                      </p>
                    </div>
                  </div>

                  <!-- 采购/利润 浅蓝色块 -->
                  <!-- <div class="gx-as__price-box">
                    <p class="gx-as__price-line">
                      <span class="gx-as__price-item">采购价：<b>{{ moneyText(pickVal(item, ['order_product.purchase_pay_amount', 'order_product.purchase_amount', 'order_product.pdd_pay_amount'])) }}</b></span>
                      <span class="gx-as__price-item">利润：<b class="gx-as__price-profit">{{ moneyText(pickVal(item, ['order_product.profit', 'profit'])) }}</b></span>
                      <span class="gx-as__price-item">代发费：<b>{{ moneyText(pickVal(item, ['order_product.freight', 'order_product.shipping_fee', 'order_product.purchase_freight'])) }}</b></span>
                    </p>
                    <p class="gx-as__price-line">
                      1688商品链接：
                    </p>
                    <p class="gx-as__price-line">
                      1688最低采购件数：
                    </p>
                  </div> -->

                  <div class=" gx-as__remark-box">
                    <!-- <p class="gx-as__remark-line" v-if="item.alibaba_aftersale">
                      <span class="gx-as__remark-k">1688售后状态：</span>
                      <span class="gx-as__tag gx-as__tag--type ali-status-tag">{{ aliStatusText(item) }}</span>
                    </p> -->
                    <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">订单备注：</span>
                      <i v-if="orderRemarkFlagShow(item)" class="el-icon-s-flag" :style="{ color: orderRemarkFlagColor(item) }"></i>
                      <span class="gx-as__remark-val" :title="orderRemarkWordsDisplay(item)">{{ orderRemarkWordsDisplay(item) }}</span>
                      <a v-if="item.order_id" href="javascript:;" class="gx-as__remark-link" @click="openRemarkDialog(item, 'order')">修改</a>
                    </p>
                    <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">售后备注：</span>
                      <span class="gx-as__remark-val" :title="aftersaleRemarkDisplay(item)">{{ aftersaleRemarkDisplay(item) }}</span>
                      <a href="javascript:;" class="gx-as__remark-link" @click="openRemarkDialog(item, 'aftersale')">修改备注</a>
                    </p>
                  </div>
                </div>
              </td>
              <!-- 金额 -->
              <td>
                <div class=" gx-as__amount">
                  <p class="gx-as__amt-label">退款金额</p>
                  <p class="gx-as__refund-amt">{{ moneyText(item.refund_amount) }}</p>
                  <p class="gx-as__amt-pay">订单应付</p>
                  <p class="gx-as__amt-pay-amt">{{ moneyText(item.order_product && item.order_product.pay_amount) }}</p>
                  <!-- <div class="gx-as__amt-detail">
                    <p class="gx-as__amt-row" v-for="(r, ri) in amtRows(item)" :key="'amt-' + ri">
                      <span class="gx-as__amt-k">{{ r.k }}</span>
                      <span class="gx-as__amt-v">{{ r.v }}</span>
                    </p>
                  </div> -->
                </div>
              </td>
              <!-- 件数 -->
              <td>
                <div class=" gx-as__count">
                  <p class="gx-as__count-num">×{{ item.aftersale_num != null && item.aftersale_num !== '' ? item.aftersale_num : '--' }}</p>
                </div>
              </td>
              <!-- 售后状态 -->
              <td>
                <div class=" gx-as__status">
                  <p class="gx-as__status-text">{{ dash(item.text_part && item.text_part.aftersale_status_text) }}</p>
                  <!-- <p class="gx-as__status-sub">抖店状态：</p>
                  <p class="gx-as__status-time">{{ dash(statusTimeText(item)) }}</p>
                  <a href="javascript:;" class="gx-as__status-more">
                    <i class="el-icon-time"></i>买家信息
                  </a> -->
                </div>
              </td>
              <!-- 原因 -->
              <td>
                <div class=" gx-as__reason">{{ dash(item.text_part && item.text_part.reason_text) }}</div>
              </td>
              <!-- 1688售后状态 -->

                            <td>
                <div class=" gx-as__status">
                  <div class="gx-as__alibaba" v-if="item.alibaba_aftersale">
                    <!-- <p class="ali-st">
                      1688售后状态：
                      <span class="gx-as__tag gx-as__tag--type ali-status-tag">{{ aliStatusText(item) }}</span>
                    </p> -->

                    <div v-if="item.alibaba_aftersale" class=" gx-as__remark-line--sep">
                      <div
                          class="gx-as__goods"
                          v-if="item.alibaba_aftersale.product && (item.alibaba_aftersale.product.img || item.alibaba_aftersale.product.name || item.alibaba_aftersale.product.sku_spec_value)"
                      >
                        <div
                            class="ali-pro-img"
                            :class="{ 'is-link': item.alibaba_aftersale.product.offer_url || item.alibaba_aftersale.product.offer_id }"
                            @click="openAlibabaOfferDetail(item.alibaba_aftersale.product)"
                        >
                          <img v-if="item.alibaba_aftersale.product.img" class="gx-as__thumb gx-as__thumb--dd" :src="item.alibaba_aftersale.product.img" alt="" />
                        </div>
                        <div class="gx-as__con-box">
                          <p
                              class="gx-as__product-title"
                              :class="{ 'is-link': item.alibaba_aftersale.product.offer_url || item.alibaba_aftersale.product.offer_id }"
                              :title="item.alibaba_aftersale.product.name || ''"
                              @click="openAlibabaOfferDetail(item.alibaba_aftersale.product)"
                          >{{ item.alibaba_aftersale.product.name || '-' }}</p>
                          <p class="gx-as__dim" :title="item.alibaba_aftersale.product.sku_spec_value || ''">
                            {{ item.alibaba_aftersale.product.sku_spec_value || '-' }}
                          </p>
                        </div>
                      </div>
                      <p class="gx-as__remark-line" style="margin-top: 8px;">
                      <span class="gx-as__remark-k">采购退款状态：</span>
                       <span class="gx-as__tag gx-as__tag--type ali-status-tag">{{ aliStatusText(item) }}</span>
                    </p>
                    <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">退款金额：</span>
                            <span class="red">¥{{ formatAliAmount(item.alibaba_aftersale.refund_amount) }}</span>
                            <span v-if="item.alibaba_aftersale.aftersale_num != null"> · {{ item.alibaba_aftersale.aftersale_num }}件</span>
                    </p>
                      <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">售后单号：</span>
                      <template v-if="item.alibaba_aftersale && item.alibaba_aftersale.refund_id">
                        <a
                          target="_blank"
                          class="gx-as__remark-link"
                          :href="'https://dispute.1688.com/refund/assureRefundDetail.htm?refundId=' + item.alibaba_aftersale.refund_id"
                          @click.stop
                        >{{ item.alibaba_aftersale.refund_id }}</a>
                        <i class="gx-as__copy" @click="bindCopy(String(item.alibaba_aftersale.refund_id))">⧉</i>
                      </template>
                      <span v-else class="gx-as__ph">--</span>
                    </p>
                    <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">采购单号：</span>
                      <a
                        v-if="item.alibaba_aftersale && item.alibaba_aftersale.alibaba_order_id"
                        target="_blank"
                        class="gx-as__remark-link"
                        :href="'https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=' + item.alibaba_aftersale.alibaba_order_id"
                        @click.stop
                      >{{ item.alibaba_aftersale.alibaba_order_id }}</a>
                      <span v-else class="gx-as__ph">--</span>
                    </p>
                    <!-- <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">采购下单：</span>
                      <span class="gx-as__remark-val">{{ dash(item.return_logistics_time) }}</span>
                    </p> -->
                    <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">采购快递单号：</span>
                      <template v-if="item.return_logistics_code">
                        <span class="gx-as__oid">{{ item.return_logistics_company_name }}{{ item.return_logistics_company_name ? ' ' : '' }}{{ item.return_logistics_code }}</span>
                        <i class="gx-as__copy" @click="bindCopy(String(item.return_logistics_code))">⧉</i>
                      </template>
                      <span v-else class="gx-as__ph">--</span>
                    </p>
                    <!-- <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">退货地址：</span>
                      <template v-if="returnAddressText(item)">
                        <i class="gx-el-icon-s-flag"></i>
                        <span class="gx-as__remark-val" :title="returnAddressText(item)">{{ returnAddressText(item) }}</span>
                      </template>
                      <span v-else class="gx-as__ph">--</span>
                    </p> -->
                     <p class="ali-ww">
                      <span class="gx-as__remark-k">上家旺旺：</span>
                      <span class="gx-as__oid">{{ aliWangwang(item) }}</span>
                      <i
                          v-if="aliChatable(item)"
                          class="el-icon-chat-dot-round ali-ww-icon"
                          style="cursor: pointer;margin-left: 8px;"
                          title="打开旺旺"
                          @click="openAlibabaWangwangChat(item.alibaba_aftersale)"
                      />
                    </p>
                    </div>

                    <!-- <p class="ali-shop">上家店铺：<span class="ali-shop-name" :title="aliShopName(item)">{{ dash(aliShopName(item)) }}</span></p> -->
                    <!-- <div class="ali-id">
                      <div>发货时效 </div>
                      <div>揽收率 </div>
                    </div>
                    <div class="ali-id">
                      <div>退款率</div>
                      <div>体验分</div>
                    </div> -->
                    <!-- <div class="ali-stats" v-if="aliStats(item).length">
                      <span class="ali-stat" v-for="(s, si) in aliStats(item)" :key="'st-' + si">{{ s.k }}<b>{{ s.v }}</b></span>
                    </div> -->
                  </div>
                </div>
              </td>
              <!-- 操作 -->
              <td>
                <div class=" gx-as__ops">
                  <button class="gx-as__op-btn" @click="goAftersaleDetail(item)">详情</button>
                </div>
              </td>
            </tr>
            <tr v-if="!list.length">
              <td :colspan="7">
                <div  class="gx-as__empty">暂无数据</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="gx-as__pager">
        <div class="gx-as__pager-left">
          <span class="gx-as__pager-total">共 {{ pageData.total }} 条</span>
          <page-size-select :value="pageData.limit" :options="pageSizeOptions" @change="onPageSizeChange" />
        </div>
        <div class="gx-as__pager-btns">
          <button class="gx-as__page" :disabled="pageData.page <= 1" @click="getList(true, pageData.page - 1)">上一页</button>
          <button v-for="n in pageNums" :key="n" class="gx-as__page" :class="{ 'gx-as__page--on': n === pageData.page }" @click="getList(true, n)">{{ n }}</button>
          <button class="gx-as__page" :disabled="pageData.page >= totalPages" @click="getList(true, pageData.page + 1)">下一页</button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getList(true, pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>

    <!-- 弹窗（复用原版组件） -->
    <aftersales-config-set-dialog ref="aftersalesConfigSetDialog" />
    <aftersale-remark-dialog
      :visible.sync="remarkDialogVisible"
      :aftersale-id="remarkDialogAftersaleId"
      :order-id="remarkDialogOrderId"
      :initial-tab="remarkDialogInitialTab"
      :initial-remark="remarkDialogInitialRemark"
      @success="onRemarkDialogSuccess"
    />
    <under-development ref="underDevelopmentRef"></under-development>
    <gx-loading :show="loading" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import MultiSelect from '../cloudOptimize/MultiSelect.vue'
import AftersalesConfigSetDialog from '../uc_after_sales/components/AftersalesConfigSetDialog.vue'
import AftersaleRemarkDialog from '../uc_after_sales/components/AftersaleRemarkDialog.vue'
import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";
import Pagination from "@/components/newUi/Pagination.vue";

const DD_AFTERSALE_BATCH_MAX = 80
const DD_AFTERSALE_BATCH_HANDLE_REFUND = 10
const DD_AFTERSALE_BATCH_HANDLE_RETURN = 20

export default {
  name: 'NewAfterSalesListPage',
  components: { MultiSelect, AftersalesConfigSetDialog, AftersaleRemarkDialog, GxLoading, PageSizeSelect,UnderDevelopment,Pagination },
  mixins: [gxLoading],
  props: {
    initialShopType: { type: Number, default: 1 },
  },
  data() {
    return {
      DD_AFTERSALE_BATCH_HANDLE_REFUND,
      DD_AFTERSALE_BATCH_HANDLE_RETURN,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchData: {
        tab_value: 0,
        shop_id: '',
        after_sale_type: '',
        type: '',
        after_sale_status: '',
        apply_reason: '',
        in_deadline: '',
        diff_deal_state: '',
        alibaba_refund_status: ''
      },
      dateStart: '',
      dateEnd: '',
      arrAfterSalesType: [],
      arrStatus: [],
      typeList: [],
      arrShop: [],
      arrApplyReason: [],
      arrAlibabaRefundStatus: [],
      arrTabList: [],
      list: [],
      checkAll: false,
      checkList: [],
      isHideOrderInfo: false,
      pageData: { limit: 20, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      batchOperateSubmitting: false,
      rowOpLoading: null,
      groupList: [],
      delDialogShow: false,
      delForm: { limit_day: '7', order_num: '', delete_day: '' },
      delSaving: false,
      syncDialogShow: false,
      syncForm: { sync_return_address_type: 10, repurchase_type: 10, sync_return_address_refund_apply_num: 1 },
      syncSaving: false,
      remarkDialogVisible: false,
      remarkDialogAftersaleId: 0,
      remarkDialogOrderId: 0,
      remarkDialogInitialTab: 'aftersale',
      remarkDialogInitialRemark: ''
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    allChecked() {
      return this.list.length > 0 && this.checkList.length === this.list.length
    },
    checkListIndeterminate() {
      const n = this.list.length
      const c = this.checkList.length
      return n > 0 && c > 0 && c < n
    }
  },
  watch:{
    initialShopType(val){
      this.currentShopType =val
      if(this.currentShopType===7){
        this.$nextTick(()=>{
          this.$refs.underDevelopmentRef.show()
        })
        this.pageData.page=1
        this.list = []
        this.pageData.total = 0
        return
      }
      this.getList()
      this.loadGroupList()
      this.initFilterData()
    }
  },
  mounted() {
    const isHideInfo = localStorage.getItem('isHideInfo')
    if (isHideInfo == 1) this.isHideOrderInfo = true
  },
  created() {
    this.currentShopType =this.initialShopType
    if(this.currentShopType===7){
      this.$nextTick(()=>{
        this.$refs.underDevelopmentRef.show()
      })
      this.pageData.page=1
      this.list = []
      this.pageData.total = 0
      return
    }

    this.getList()
    this.loadGroupList()
    this.initFilterData()
  },
  methods: {
    ...mapActions({
      getAfterSalesfilterData: 'ucenter_order/getAfterSalesfilterData',
      getOrderAfterSalesList: 'ucenter_order/getOrderAfterSalesList',
      opDdAftersaleBatchOperate: 'ucenter_order/opDdAftersaleBatchOperate',
      opDdAftersaleOperate: 'ucenter_order/opDdAftersaleOperate',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      getStrategyDeleteSet: 'ucenter_order/getStrategyDeleteSet',
      opEditStrategyDeleteSet: 'ucenter_order/opEditStrategyDeleteSet',
      getUserinfoData: 'ucenter_order/getUserinfoData',
      opBusinessSetSyncReturnAddressType: 'ucenter_order/opBusinessSetSyncReturnAddressType'
    }),
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    initFilterData() {
      let group_ids = ''
      if (Array.isArray(this.searchData.group_ids) && this.searchData.group_ids.length === 0) group_ids = ''
      else if (!this.searchData.group_ids) group_ids = ''
      else group_ids = this.searchData.group_ids
      if (this.$store.state.login.user_level == 9 && group_ids) {
        this.searchData.group_ids = []
        this.$message.error('普通会员无法使用分组')
        return
      }
      this.getAfterSalesfilterData({
        data: { group_ids },
        success: (res) => {
          if (res.code === 200) {
            this.arrShop = res.data.arr_shop || []
            this.arrAfterSalesType = res.data.aftersale_type || []
            if (this.arrAfterSalesType.length) {
              this.typeList = this.arrAfterSalesType[0].type_list || []
              this.arrStatus = this.arrAfterSalesType[0].status_list || []
              this.searchData.after_sale_type = this.arrAfterSalesType[0].val
            }
            this.arrTabList = res.data.tab_list || []
            this.arrApplyReason = Array.isArray(res.data.arr_apply_reason) ? res.data.arr_apply_reason : []
            this.arrAlibabaRefundStatus = res.data.arr_alibaba_refund_status || []
          }
        }
      })
    },
    tabBadgeCount(tabItem) {
      if (!tabItem || tabItem.count_num === undefined || tabItem.count_num === null || tabItem.count_num === '') return 0
      const n = parseInt(tabItem.count_num, 10)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    changeStatus(e) {
      const item = this.arrAfterSalesType.find(item => item.val == e)
      if (item) {
        this.typeList = item.type_list || []
        this.arrStatus = item.status_list || []
      }
      this.refresh(false)
    },
    onTabChange(e) {
      this.searchData.tab_value = e
      if (e == 100 || e == 110) {
        this.searchData.after_sale_type = 100
        this.changeStatus(100)
      } else if (e == 120) {
        this.searchData.after_sale_type = 200
        this.changeStatus(200)
      } else if (e == 130) {
        this.searchData.after_sale_type = 300
        this.changeStatus(300)
      } else {
        this.searchData.after_sale_type = 0
        this.changeStatus(0)
      }
    },
    syncDate() {
      if (this.dateStart && this.dateEnd) {
        this.searchData.search_date = [this.dateStart.replace('T', ' '), this.dateEnd.replace('T', ' ')]
      } else {
        delete this.searchData.search_date
      }
    },
    resetSearch() {
      this.searchData = {
        tab_value: '',
        shop_id: '',
        after_sale_type: '',
        type: '',
        after_sale_status: '',
        apply_reason: '',
        in_deadline: '',
        diff_deal_state: '',
        alibaba_refund_status: ''
      }
      this.dateStart = ''
      this.dateEnd = ''
      this.checkList = []
      this.getList()
    },
    refresh(nowPage = true) {
      if (!nowPage) this.pageData.page = 1
      this.checkList = []
      this.getList()
    },
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getList(true, 1)
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      const param = { limit: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      this.loadingStart()
      this.getOrderAfterSalesList({
        data: param,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.list = res.data.data || []
            this.pageData.total = res.data.total || 0
            const idSet = new Set(this.list.map((row) => row.id))
            this.checkList = this.checkList.filter((id) => idSet.has(id))
            this.checkAll = this.list.length > 0 && this.checkList.length === this.list.length
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }
      })
    },
    toggleOne(id) {
      if (id == null) return
      const idx = this.checkList.indexOf(id)
      if (idx > -1) this.checkList.splice(idx, 1)
      else this.checkList.push(id)
    },
    bindCheckAll(val) {
      this.checkList = val ? this.list.map((row) => row.id).filter((id) => id != null) : []
    },
    bindCopy(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$message({ message: '复制成功', type: 'success' })
    },
    openImg(row) {
      if (!row) return
      const htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_pic + '" alt="">' +
        '<div style="margin-top:10px;font-size:16px;">' + row.spec_value + '</div>' +
        '<div style="margin-top:5px;font-size:16px;">实付:￥' + row.pay_amount + '</div>'
      this.$alert(htm, row.product_name, {
        dangerouslyUseHTMLString: true,
        showClose: false,
        confirmButtonText: '关闭',
        closeOnClickModal: true,
        customClass: 'zdy-message-box'
      })
    },
    goAftersaleDetail(row) {
      if (!row || !row.id) {
        this.$message({ message: '缺少售后记录 ID', type: 'warning' })
        return
      }
      this.$router.push({
        path: '/new_aftersales_workbench',
        query: {
          menu:`${this.initialShopType===1?'dou':'wx'}-after-mag`,
          id: row.id
        }
      })
    },
    orderRemarkWordsDisplay(item) {
      const words = item && item.order_remark && item.order_remark.seller_words
      if (words == null || String(words).trim() === '') return '暂无'
      return String(words)
    },
    orderRemarkFlagShow(item) {
      const remark = item && item.order_remark
      if (!remark) return false
      if (remark.seller_remark_starts_info && typeof remark.seller_remark_starts_info === 'object') return true
      return remark.seller_remark_stars != null && remark.seller_remark_stars !== ''
    },
    orderRemarkFlagColor(item) {
      const remark = item && item.order_remark
      if (!remark) return '#c0c4cc'
      const info = remark.seller_remark_starts_info
      if (info && typeof info === 'object' && info.color) return info.color
      return '#c0c4cc'
    },
    aftersaleRemarkDisplay(item) {
      const remark = item && item.remark
      if (remark == null || String(remark).trim() === '') return '暂无'
      return String(remark)
    },
    openRemarkDialog(item, tab = 'aftersale') {
      if (!item || !item.id) {
        this.$message.warning('售后数据未就绪')
        return
      }
      const orderId = Number(item.order_id)
      this.remarkDialogAftersaleId = Number(item.id)
      this.remarkDialogOrderId = Number.isFinite(orderId) ? orderId : 0
      this.remarkDialogInitialTab = tab === 'order' && this.remarkDialogOrderId ? 'order' : 'aftersale'
      this.remarkDialogInitialRemark = this.aftersaleRemarkDisplay(item) === '暂无' ? '' : this.aftersaleRemarkDisplay(item)
      this.remarkDialogVisible = true
    },
    onRemarkDialogSuccess() {
      this.getList(false)
    },
    /* ── 售后设置 / 地址 ── */
    openAftersaleConfigSet() {
      this.$refs.aftersalesConfigSetDialog.open()
    },
    editReturnAddressExpireDay() {
      this.delDialogShow = true
      this.delSaving = false
      this.getStrategyDeleteSet({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const d = res.data || {}
            this.delForm = {
              limit_day: d.limit_day != null && d.limit_day !== '' ? String(d.limit_day) : '7',
              order_num: d.order_num != null && d.order_num !== '' ? String(d.order_num) : '',
              delete_day: d.delete_day != null && d.delete_day !== '' ? String(d.delete_day) : ''
            }
          } else {
            this.$message({ message: res.msg || '获取设置失败', type: 'error' })
          }
        }
      })
    },
    saveDeleteRule() {
      if (this.delForm.limit_day == null || this.delForm.limit_day === '') {
        this.$message({ message: '请选择统计周期', type: 'warning' })
        return
      }
      const orderNum = Number(this.delForm.order_num)
      if (this.delForm.order_num === '' || Number.isNaN(orderNum) || orderNum < 0 || !Number.isInteger(orderNum)) {
        this.$message({ message: '请输入有效的订单量阈值（非负整数）', type: 'warning' })
        return
      }
      const deleteDay = Number(this.delForm.delete_day)
      if (this.delForm.delete_day === '' || Number.isNaN(deleteDay) || deleteDay < 1 || !Number.isInteger(deleteDay)) {
        this.$message({ message: '请输入有效的自动删除天数（正整数）', type: 'warning' })
        return
      }
      if (this.delSaving) return
      this.delSaving = true
      this.opEditStrategyDeleteSet({
        data: { limit_day: Number(this.delForm.limit_day), order_num: orderNum, delete_day: deleteDay },
        success: (res) => {
          this.delSaving = false
          if (res.code === 200) {
            this.$message({ message: res.msg || '保存成功', type: 'success' })
            this.delDialogShow = false
          } else {
            this.$message({ message: res.msg || '保存失败', type: 'error' })
          }
        }
      })
    },
    editSyncReturnAddressSet() {
      this.syncDialogShow = true
      this.syncSaving = false
      this.getUserinfoData({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.syncForm.sync_return_address_type = res.data.sync_return_address_type != null ? Number(res.data.sync_return_address_type) : 10
            this.syncForm.repurchase_type = res.data.repurchase_type != null ? Number(res.data.repurchase_type) : 10
            this.syncForm.sync_return_address_refund_apply_num = res.data.sync_return_address_refund_apply_num != null ? Number(res.data.sync_return_address_refund_apply_num) : 1
          }
        }
      })
    },
    saveSyncRule() {
      if (this.syncSaving) return
      this.syncSaving = true
      this.opBusinessSetSyncReturnAddressType({
        data: this.syncForm,
        success: (res) => {
          this.syncSaving = false
          if (res.code === 200) {
            this.$message.success(res.msg || '保存成功')
            this.syncDialogShow = false
          } else {
            this.$message.error(res.msg || res.message)
          }
        }
      })
    },
    /* ── 批量处理 ── */
    bindBatchAftersaleOperate(handleType) {
      const title = handleType === DD_AFTERSALE_BATCH_HANDLE_REFUND ? '批量同意退款' : '批量同意退货'
      if (!this.checkList.length) {
        this.$message({ message: '请先勾选售后', type: 'warning' })
        return
      }
      if (this.checkList.length > DD_AFTERSALE_BATCH_MAX) {
        this.$message({ message: `单次最多处理 ${DD_AFTERSALE_BATCH_MAX} 条，请减少勾选数量`, type: 'warning' })
        return
      }
      const ids = [...this.checkList]
      this.$confirm(`确认对已选的 ${ids.length} 条售后执行「${title}」？系统将逐条刷新并调用抖店接口，单条失败不影响其它条目。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => this.submitBatchAftersaleOperate(handleType, ids)).catch(() => {})
    },
    submitBatchAftersaleOperate(handleType, ids) {
      this.batchOperateSubmitting = true
      this.opDdAftersaleBatchOperate({
        data: { handle_type: handleType, ids },
        success: (res) => {
          this.batchOperateSubmitting = false
          if (res.code !== 200) {
            this.$message({ message: res.msg || '请求失败', type: 'error' })
            return
          }
          const d = res.data || {}
          const ok = Number(d.success_count) || 0
          const fail = Number(d.fail_count) || 0
          const items = Array.isArray(d.items) ? d.items : []
          const summary = `处理完成：成功 ${ok} 条，失败 ${fail} 条`
          if (fail > 0 && items.length) {
            const fails = items.filter((x) => x && x.ok !== true)
            const lines = fails.slice(0, 30).map((x) => `ID ${x.id}：${x.msg || '失败'}`).join('<br/>')
            const more = fails.length > 30 ? `<br/>… 共 ${fails.length} 条失败，仅显示前 30 条` : ''
            this.$alert(lines + more, summary, {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              customClass: 'zdy-message-box'
            })
          } else {
            this.$message({ message: summary, type: fail > 0 ? 'warning' : 'success' })
          }
          this.checkList = []
          this.getList()
        }
      })
    },

    formatAliAmount(v) {
      const n = Number(v);
      if (!Number.isFinite(n)) return '0.00';
      return n.toFixed(2);
    },
    /* 按路径安全取值，多候选路径返回第一个非空值 */
    pickVal(item, paths) {
      for (const p of paths) {
        const v = p.split('.').reduce((o, k) => (o == null ? o : o[k]), item)
        if (v != null && v !== '') return v
      }
      return ''
    },
    hasPriceBox(item) {
      return !!(
        this.pickVal(item, ['order_product.purchase_pay_amount', 'order_product.purchase_amount', 'order_product.pdd_pay_amount']) ||
        this.pickVal(item, ['order_product.profit', 'profit']) ||
        this.pickVal(item, ['order_product.freight', 'order_product.shipping_fee', 'order_product.purchase_freight'])
      )
    },
    aliReason(item) {
      const a = item && item.alibaba_aftersale
      if (!a) return ''
      return a.reason_text || a.refund_reason || a.apply_reason || a.reason || ''
    },
    aliAddressStatus(item) {
      const a = item && item.alibaba_aftersale
      if (!a) return ''
      return a.address_status_text || a.return_address_state_text || a.addr_status_text || ''
    },
    formatAddress(addr) {
      if (!addr) return ''
      if (typeof addr === 'string') return addr
      if (typeof addr !== 'object') return ''
      return [addr.name, addr.phone, addr.province, addr.city, addr.town, addr.street, addr.detail]
        .filter((x) => x != null && x !== '')
        .join(' ')
    },
    returnAddressText(item) {
      return this.formatAddress(item && item.return_address)
    },
    aliReturnAddressText(item) {
      const a = item && item.alibaba_aftersale
      return this.formatAddress(a && a.return_address)
    },
    fmtAmt(v) {
      if (v == null || v === '') return ''
      const n = Number(v)
      return Number.isFinite(n) ? '¥' + n.toFixed(2) : '¥' + v
    },
    /* 空值占位：null/undefined/空字符串/空白字符串 显示 -- */
    dash(v) {
      if (v === null || v === undefined) return '--'
      return String(v).trim() === '' ? '--' : v
    },
    /* 金额占位：无值显示 --，有值加 ¥ 前缀 */
    moneyText(v) {
      if (v === null || v === undefined || String(v).trim() === '') return '--'
      const n = Number(v)
      return Number.isFinite(n) ? '¥' + n.toFixed(2) : '¥' + v
    },
    amtRows(item) {
      const rows = []
      const push = (k, paths) => {
        const v = this.pickVal(item, paths)
        rows.push({ k, v: v === '' ? '--' : this.fmtAmt(v) })
      }
      push('实付金额', ['pay_amount_text', 'pay_amount', 'order_product.real_pay_amount', 'order_product.actual_pay_amount', 'order_product.pay_amount'])
      push('补偿款', ['order_product.compensate_amount', 'order_product.compensation_amount', 'compensate_amount', 'compensation_amount'])
      push('平台优惠', ['order_product.promotion_platform_amount', 'promotion_platform_amount', 'platform_discount_amount'])
      push('精选联盟', ['order_product.merchant_receive_amount', 'merchant_receive_amount', 'seller_receive_amount', 'merchant_amount'])
      return rows
    },
    aliOf(item) {
      return (item && item.alibaba_aftersale) || {}
    },
    aliProductName(item) {
      const a = this.aliOf(item)
      return (a.product && a.product.name) || ''
    },
    aliStatusText(item) {
      return this.aliOf(item).refund_status_text || '--'
    },
    aliWangwang(item) {
      return this.aliOf(item).wangwang_account || '--'
    },
    aliChatable(item) {
      const a = this.aliOf(item)
      return !!(a.wangwang_account || a.wangwang_chat_url)
    },
    aliRefundId(item) {
      return this.aliOf(item).refund_id || ''
    },
    aliRefundAmount(item) {
      const v = this.aliOf(item).refund_amount
      if (v === null || v === undefined || v === '') return '--'
      return '¥' + this.formatAliAmount(v)
    },
    aliNum(item) {
      const v = this.aliOf(item).aftersale_num
      return v === null || v === undefined || v === '' ? '' : v
    },
    sourceChannel(item) {
      return this.pickVal(item, ['source_channel_text', 'channel_text', 'source_text', 'order_source_text', 'text_part.source_channel_text', 'source_channel'])
    },
    statusSubText(item) {
      return this.pickVal(item, ['text_part.arrival_status_text', 'arrival_status_text', 'text_part.sub_status_text', 'sub_status_text', 'text_part.refund_status_text'])
    },
    statusTimeText(item) {
      return this.pickVal(item, ['text_part.status_time_text', 'status_time_text', 'last_operate_time_text', 'text_part.last_time_text', 'status_update_time'])
    },
    aliShopName(item) {
      const a = item && item.alibaba_aftersale
      if (!a) return ''
      return this.pickVal(a, ['shop_name', 'supplier_name', 'company_name', 'shop_title', 'seller_shop_name', 'seller_name'])
    },
    rowOps(item) {
      return Array.isArray(item && item.operate_type_list) ? item.operate_type_list : []
    },
    opNeedForm(op) {
      const other = Array.isArray(op && op.other) ? op.other : []
      return other.some((o) => /reject_reason_code|evidence|ReceiverAddressId|logistics\./i.test(String(o)))
    },
    onRowOp(item, op) {
      if (!op || this.rowOpLoading != null) return
      if (this.opNeedForm(op)) {
        this.goAftersaleDetail(item)
        return
      }
      this.$confirm(`确认执行「${op.text}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.rowOpLoading = item.id
        this.opDdAftersaleOperate({
          data: { id: item.id, type: op.val },
          success: (res) => {
            this.rowOpLoading = null
            if (res.code === 200) {
              this.$message.success(res.msg || '操作成功')
              this.getList(false)
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          }
        })
      }).catch(() => {})
    },
    quickAgree(item) {
      const isReturn = /退货/.test((item.text_part && item.text_part.aftersale_type_text) || '')
      const handleType = isReturn ? DD_AFTERSALE_BATCH_HANDLE_RETURN : DD_AFTERSALE_BATCH_HANDLE_REFUND
      const title = isReturn ? '同意退货' : '同意退款'
      this.$confirm(`确认对该售后执行「${title}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitBatchAftersaleOperate(handleType, [item.id])
      }).catch(() => {})
    },
    aliStats(item) {
      const a = item && item.alibaba_aftersale
      if (!a) return []
      const stats = []
      const refundRate = a.refund_rate_text || a.refund_rate
      if (refundRate != null && refundRate !== '') stats.push({ k: '退款率 ', v: refundRate })
      const returnRate = a.return_rate_text || a.return_rate
      if (returnRate != null && returnRate !== '') stats.push({ k: '退货率 ', v: returnRate })
      const avgPrice = a.avg_price_text || a.avg_price
      if (avgPrice != null && avgPrice !== '') stats.push({ k: '均价 ', v: avgPrice })
      return stats
    },
    openAlibabaWangwangChat(ali) {
      const row = ali || {};
      const url = String(row.wangwang_chat_url || '').trim();
      if (url) {
        window.open(url, '_blank');
        return;
      }
      const account = String(row.wangwang_account || '').trim();
      if (!account) {
        this.$message({ message: '暂无上家旺旺', type: 'warning' });
        return;
      }
      const wangwangId = account.replace(/^cnalichn/i, '');
      const touid = encodeURIComponent('cnalichn' + wangwangId);
      window.open(
          `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`,
          '_blank'
      );
    },
    openAlibabaOfferDetail(product) {
      const p = product || {};
      let url = String(p.offer_url || '').trim();
      if (!url && p.offer_id) {
        const id = String(p.offer_id).trim();
        url = `https://detail.1688.com/offer/${id}.html?offerId=${id}`;
      }
      if (!url) {
        this.$message({ message: '暂无1688商品链接', type: 'warning' });
        return;
      }
      window.open(url, '_blank');
    },
  }
}
</script>

<style scoped>
.gx-as__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
}
.gx-as__filter-btn{
  height: 30px;
  padding: 0 16px;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(245, 245, 245);
  border: 1px solid rgb(224, 224, 236);
  box-sizing: border-box;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(26, 26, 46);
  transition: 0.15s;
}
.gx-as__filter-btn:hover{
  background: rgb(232,232,232);
}
.gx-as__filter-btn~.gx-as__filter-btn{
  margin-left: 8px;
}

.gx-as__fitem {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-as__flabel {
  font-size: 12px;
  color: #4A4A6A;
  white-space: nowrap;
}
.gx-as__fitem--btns {
  margin-left: auto;
}
.gx-as__input {
  width: 140px;
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FAFBFC;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.gx-as__input:hover {
  border-color: #C8CCD4;
}
.gx-as__input:focus {
  border-color: #C8443C;
  background: #FFFFFF;
  box-shadow: 0 0 0 2px rgba(200, 68, 60, 0.08);
}
.gx-as__input--date {
  width: 165px;
}
.gx-as__range-sep {
  color: #6A6A8A;
  font-size: 12px;
}
.gx-as__select {
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FAFBFC;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  min-width: 110px;
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.gx-as__select:hover {
  border-color: #C8CCD4;
}
.gx-as__select:focus {
  border-color: #C8443C;
  background: #FFFFFF;
  box-shadow: 0 0 0 2px rgba(200, 68, 60, 0.08);
}
/* placeholder 状态：未选择时显示灰色 */
.gx-as__select:invalid {
  color: #B0B0B5;
}
.gx-as__select option {
  color: #1A1A2E;
}
.gx-as__select option[value=""] {
  display: none;
}
.gx-as__btn {
  height: 30px;
  padding: 0 14px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #E4E7ED;
  font-size: 12px;
  color: #4A4A6A;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s ease;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
}
.gx-as__btn:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(200, 68, 60, 0.10);
}
.gx-as__btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
}
.gx-as__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-as__btn--mi{
  height: 26px;
  padding: 0px 9px;
  border-radius: 6px;
  font-size: 11px;
}
.gx-as__btn--pink {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
  font-weight: 500;
}
.gx-as__btn--pink:hover:not(:disabled) {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-as__btn--plain {
  background: #FFFFFF;
  border-color: #E4E7ED;
  color: #4A4A6A;
}
.gx-as__btn--plain:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-as__btn--primary {
  background: #C8443C;
  border-color: #C8443C;
  font-weight: 600;
  color: #fff;
}
.gx-as__btn--primary:hover:not(:disabled) {
  background: #B83A33;
  border-color: #B83A33;
  color: #fff;
}
.gx-as__status-tabs {
  display: flex;
  margin-bottom: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  background: #FFFFFF;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #EFE6D2;
  /* padding: 0 10px; */
  position: relative;
  z-index: 2;
  /* gap: 2px; */
}
.gx-as__status-tab {
  padding: 13px 16px 11px;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  background: rgb(245, 240, 232);
  font-size: 13px;
  color: #4a4a6a;
  font-weight: 400;
  position: relative;
  white-space: nowrap;
  flex-shrink: 0;
  border-radius: 0;
  transition: color .15s ease, border-color .15s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;

}
.gx-as__status-tab~.gx-as__status-tab{
  border-left: 1px solid rgb(224, 224, 236);
}
.gx-as__status-tab--on {
  background: rgb(255, 245, 245);
  border-bottom-color: #C8443C;
  color: #C8443C;
  font-weight: 600;
}
.gx-as__status-tab--on:hover {
  color: #C8443C;
  background: #FDECEB;
}
.gx-as__status-num {
  position: absolute;
  top: 5px;
  right: 3px;
  min-width: 15px;
  height: 15px;
  padding: 0 4px;
  border-radius: 8px;
  background: #E04B43;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  line-height: 15px;
  text-align: center;
  box-sizing: border-box;
}
.gx-as__status-tab--on .gx-as__status-num {
  background: #E04B43;
  color: #fff;
}
.gx-as__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232);
  flex-wrap: wrap;
}
.gx-as__toolbar .gx-as__divider {
  width: 1px;
  height: 18px;
  background: rgb(224, 224, 236);
}
.gx-as__batch-label {
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  color: rgb(26, 26, 46);
  font-weight: 600;
  white-space: nowrap;
}
.gx-as__toolbar .gx-as__btn {
  box-shadow: none;
}
.gx-as__toolbar .gx-as__btn:hover:not(:disabled) {
  transform: none;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
}
.gx-as__th-check {
  width: 14px;
  flex-shrink: 0;
  margin: 0 12px 0 16px;
}
.gx-as__card {
  border-radius: 10px;
  border: 1px solid #EBEEF5;
  background: #FFFFFF;
  overflow: visible;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
  position: relative;
}
.gx-as__thead {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 0;
  padding: 0;
  background: #FAF6EE;
  border-bottom: 1px solid #EFE6D2;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  border-radius: 0;
}
.gx-as__checkall {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
/*  width: 90px;*/
  flex-shrink: 0;
  user-select: none;
}
.gx-as__checkall input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-as__checkall-box {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}
.gx-as__checkall input:checked + .gx-as__checkall-box {
  background: #C8443C;
  border-color: #C8443C;
}
.gx-as__checkall-dash {
  width: 7px;
  height: 2px;
  border-radius: 1px;
  background: #C8443C;
}

.gx-as__table tr{
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-as__table th{
  padding: 9px 10px;
  text-align: left;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  border-right: 1px solid rgb(224, 224, 236);
  white-space: nowrap;
  background: rgb(245, 240, 232);
}
.gx-as__table td{
  padding: 10px;
  border-right: 1px solid rgb(224, 224, 236);

}

/* ── 列表行：flex 列布局，列宽与表头一致 ── */
.gx-as__order-main > .gx-as__check {
  align-self: center;
  margin: 0 12px 0 16px;
  flex-shrink: 0;
}
.gx-as__col-info {
  flex: 1 1 33%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
}
.gx-as__col-info > .gx-as__goods {
  margin-top: 2px;
}
/* 首列：单号信息行 */
.gx-as__info-lines {
  display: flex;
  flex-direction: column;
  gap: 1px;
  /* padding: 8px 10px; */
  /* background: #F4F7FA; */
  /* border: 1px solid #E1E8EF; */
  border-radius: 6px;
  margin-bottom: 2px;
}
.gx-as__info-line {
  margin: 0;
  font-size: 11px;
  line-height: 1.7;
  color: #606266;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.gx-as__info-k {
  color: #999;
  flex-shrink: 0;
}
.gx-as__info-v {
  color: #666;
}
.gx-as__shop-deleted {
  color: #C8443C;
}
/* 首列：双商品图 */
.gx-as__goods {
  display: flex;
  gap: 10px;
  margin: 0;
  min-width: 0;
}
.gx-as__thumbs {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.gx-as__thumb-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  width: 52px;
}
.gx-as__thumb-cell .gx-as__thumb {
  width: 48px;
  height: 48px;
  cursor: zoom-in;
}
.gx-as__thumb-label {
  font-size: 10px;
  line-height: 1;
  color: #999;
}
.gx-as__thumb-label--ali {
  color: #1677FF;
}
.gx-as__thumb-label--dd {
  color: #C8443C;
}
.gx-as__thumb--dd {
  border-color: #FFB3AE;
  background: #FFF7F6;
}
.gx-as__thumb--ali {
  border-color: #A9CBFF;
  background: #F2F7FF;
}
.gx-as__thumb--empty {
  border-style: dashed;
  border-color: #C9D8F0;
  background: #F7FAFF;
  color: #B0BECF;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}
.gx-as__thumb-label--off {
  color: #B0BECF;
}
.gx-as__ph {
  color: #C0C4CC;
}
.gx-as__ali-name.gx-as__ph {
  color: #C0C4CC;
}
.gx-as__ali-name {
  margin: 0 0 3px;
  font-size: 12px;
  color: #C8443C;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-as__ali-name:not(.gx-as__ph):hover {
  color: #B83A33;
  cursor: pointer;
}
.gx-as__goods-tags {
  margin: 0 0 4px;
  display: flex;
  gap: 6px;
}
.gx-as__tag--red {
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  color: #C8443C;
}
.gx-as__code-line {
  margin: 1px 0 !important;
  line-height: 1.6;
}
/* 首列：采购/利润 浅蓝块 */
.gx-as__price-box {
  background: linear-gradient(180deg, #ECF6FE 0%, #DEF0FB 100%);
  border: 1px solid #BFDDF3;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 12px;
  color: #4A6A8A;
  margin-top: 2px;
}
.gx-as__price-line {
  margin: 0;
  line-height: 1.85;
  display: flex;
  flex-wrap: wrap;
  gap: 0 20px;
}
.gx-as__price-item {
  color: #4A4A6A;
}
.gx-as__price-item b {
  color: #1A1A2E;
  font-weight: 600;
}
.gx-as__price-item .gx-as__price-profit {
  color: #FA8C16;
}
/* 首列：备注灰色块 */
.gx-as__remark-box {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  background: rgb(249, 247, 245);
  border-radius: 4px;
  border: 1px solid rgb(224, 224, 236);
}
.gx-as__remark-box .gx-as__remark-line {
  margin: 0;
  font-size: 12px;
  line-height: 1.7;
}
.gx-as__remark-box .gx-as__remark-line--sep {
  margin-top: 4px;
  padding-top: 6px;
  border-top: 1px dashed #EADFC6;
}
.gx-as__remark-box .gx-as__remark-val {
  max-width: 420px;
}


.gx-as__info-top {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #FFFCFC;
  border-bottom: 1px solid #F5EBEB;
  flex-wrap: wrap;
  font-size: 12px;
  color: #666;
}
.gx-as__sep {
  color: #999;
  margin-left: 8px;
}
.gx-as__oid {
  color: #409EFF;
  font-weight: 500;
  /* cursor: pointer; */
}
.gx-as__oid:hover {
  /* text-decoration: underline; */
  /* color: #0E5DD8; */
}
.gx-as__date {
  color: #666;
  margin-left: auto;
}
.gx-as__info-top .gx-as__tag {
  margin-left: 12px;
}
.gx-as__shop--deleted {
  color: #C8443C !important;
}
.gx-as__order-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #666;
  flex: 1;
  min-width: 300px;
}
.gx-as__head-num {
  display: flex;
  align-items: center;
  margin: 0;
  color: #666;
}
.gx-as__shop {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  margin-right: 2px;
  color: rgb(106, 106, 138);
  font-weight: 600;
}
.gx-as__head-date {
  margin: 0 0 0 12px;
  color: #666;
}
.gx-as__copy {
  cursor: pointer;
  margin-left: 6px;
  color: #909399;
  font-style: normal;
  font-size: 11px;
  transition: color .15s ease;
}
.gx-as__copy:hover {
  color: #C8443C;
}
.gx-as__order-flag {
  display: flex;
  gap: 5px;
}
.gx-as__tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.5;
  white-space: nowrap;
  letter-spacing: 0.2px;
}
.gx-as__tag--type {
  background: #FFF7E6;
  border: 1px solid #FFD591;
  color: #FA8C16;
}
.goods_alibaba .ali-shop {
  margin: 0 0 4px;
  color: #333;
  font-weight: 500;
  line-height: 1.6;
  word-break: break-all;
}
.goods_alibaba .ali-shop .ali-shop-name {
  font-weight: 400;
  color: #333;
}
.gx-as__check {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all .15s ease;
}
.gx-as__check svg {
  width: 7px;
  height: 7px;
}
.gx-as__check:hover {
  border-color: #C8443C;
}
.gx-as__check--on {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-as__order-info {
  display: flex;
  align-items: flex-start;
  padding: 16px 14px;
  gap: 0;
  border-bottom: 1px solid #F0F0F0;
}
.gx-as__goods {
  display: flex;
  gap: 10px;
}
.gx-as__thumb {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background: #F8F8F8;
  border: 1px solid #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
  cursor: zoom-in;
  transition: transform .15s ease, box-shadow .15s ease;
}
.gx-as__thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.10);
}
.gx-as__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-as__thumb.is-link {
  cursor: pointer;
}
.gx-as__con-box {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 1.6;
}
.gx-as__product-title {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.4;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 0 3px;
}
.gx-as__product-title:hover {
  color: #C8443C;
}
.gx-as__dim {
  color: #909399;
  margin: 2px 0;
  font-size: 12px;
}


.gx-as__refund-amt {
  font-size: 18px;
  font-weight: 700;
  color: #C8443C;
  margin: 0 0 4px !important;
  line-height: 1.3;
  letter-spacing: -0.3px;
}
/* 金额列 */
.gx-as__amount {
  min-width: 110px;
  vertical-align: top;
  text-align: center;
}
.gx-as__amount > p {
  margin: 3px 0;
}
.gx-as__amt-label {
  margin: 0 0 2px !important;
  font-size: 11px;
  color: #909399;
}
.gx-as__amt-pay {
  margin: 6px 0 0;
  font-size: 11px;
  color: #909399;
}
.gx-as__amt-pay-amt {
  margin: 1px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.gx-as__amt-detail {
  width: 100%;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #EBEEF5;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.gx-as__amt-row {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  line-height: 1.6;
  color: #909399;
}
.gx-as__amt-v {
  color: #606266;
  font-weight: 500;
}
/* 件数列 */
.gx-as__count {
  width: 70px;
  flex-shrink: 0;
  font-size: 12px;
}
.gx-as__count-num {
  margin: 0;
  font-weight: 600;
  color: #333;
}
/* 原因列 */
.gx-as__reason {
  min-width: 90px;
  flex-shrink: 0;
  font-size: 12px;
  vertical-align: middle;
  text-align: center;
  color:var(--gx-black);
  line-height: 1.5;
}

/* 售后状态列 */
.gx-as__status {
  flex: 1 1 24%;
  min-width: 150px;
  flex-shrink: 0;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.gx-as__status-text {
  flex-shrink: 0;
  display: inline-block;
  color: #FA8C16;
  background: linear-gradient(180deg, #FFF7E6 0%, #FFEFD0 100%);
  border: 1px solid #FFD591;
  border-radius: 4px;
  padding: 3px 10px;
  margin: 0;
  font-weight: 600;
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0.2px;
}
.gx-as__alibaba{
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  font-size: 12px;
  line-height: 1.6;
  color: #303133;
  word-break: break-all;
  padding: 7px 9px;
  margin: 6px 0 0;
  background: linear-gradient(180deg, #FFFBEC 0%, #FFF8DF 100%);
  border: 1px solid #F5E2A6;
  border-radius: 6px;
}
.gx-as__status-sub {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #666;
  text-align: center;
}
.gx-as__status-time {
  margin: 2px 0 0;
  font-size: 11px;
  line-height: 1.5;
  color: #999;
  text-align: center;
}
.gx-as__status-more {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.6;
  color: #C8443C;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.gx-as__status-more i {
  font-size: 13px;
}
.gx-as__status-more:hover {
  text-decoration: underline;
}

.goods_alibaba .ali-st {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.goods_alibaba .ali-status-tag {
  padding: 1px 6px;
  font-size: 11px;
}
.goods_alibaba .ali-reason {
  color: #333;
}
.goods_alibaba .ali-addr {
  color: #666;
  margin: 0 0 4px;
}
.goods_alibaba .ali-addr-text {
  color: #333;
}
.goods_alibaba .ali-stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px 12px;
  margin-top: 6px;
  color: #999;
  font-size: 11px;
}
.goods_alibaba .ali-stat b {
  color: #FA8C16;
  font-weight: 600;
  margin-left: 2px;
}

.red {
  color: #C8443C;
  font-weight: 600;
}
.goods_alibaba .ali-product {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.goods_alibaba .ali-pro-img {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
  background: #F8F8F8;
  flex-shrink: 0;
}
.goods_alibaba .is-link {
  cursor: pointer;
}
.goods_alibaba .ali-pro-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.goods_alibaba .ali-pro-body {
  min-width: 0;
  flex: 1;
}
.goods_alibaba .ali-pro-title {
  margin: 0 0 4px;
  color: #333;
  line-height: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.goods_alibaba .ali-pro-title.is-link:hover {
  color: #409EFF;
}
.goods_alibaba .ali-pro-spec {
  margin: 0;
  color: #999;
  line-height: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.goods_alibaba .ali-st {
  color: #333;
  font-weight: 500;
  margin: 0 0 4px;
}
.goods_alibaba .ali-amt {
  color: #f0413e;
  margin: 0 0 4px;
}
.goods_alibaba .ali-id,
.goods_alibaba .ali-oid,
.goods_alibaba .ali-ww {
  color: #666;
  margin: 0 0 2px;
}
.goods_alibaba .ali-id {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.goods_alibaba div{
    width: 50%;
  }
.goods_alibaba .ali-ww span {
  color: #409EFF;
}

.goods_alibaba a {
  color: #409EFF;
}

.goods_alibaba a:hover {
  text-decoration: underline;
}

.goods_alibaba .iconfont {
  cursor: pointer;
  font-size: 12px;
  color: #666;
  margin-left: 4px;
}

.goods_alibaba .ali-ww-icon {
  margin-left: 4px;
  cursor: pointer;
  color: #409EFF;
  font-size: 14px;
  vertical-align: middle;
}

.goods_alibaba .ali-empty {
  color: #C0C4CC;
  margin: 0;
}
/* 操作列 */
.gx-as__ops {
  min-width: 90px;
  flex-shrink: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  padding: 14px 8px;
  box-sizing: border-box;
}
.gx-as__op-btn {
  height: 26px;
  padding: 0px 12px;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgb(200, 68, 60);
  transition: 0.15s;
}
.gx-as__op-btn:hover:not(:disabled) {
  background: #C8443C;
  border-color: #C8443C;
  color: #ffffff;
}
.gx-as__op-btn:active:not(:disabled) {
  transform: translateY(0);
}
.gx-as__op-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-as__link {
  color: #C8443C;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
}
.gx-as__link:hover {
  text-decoration: underline;
}
.gx-as__strong {
  font-weight: 600;
  color: #333;
}
.gx-as__gold {
  color: #C8443C;
  font-weight: 700;
}
.gx-as__info-bottom {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 14px;
  flex-wrap: wrap;
  font-size: 12px;
  background: #FAF6EE;
  border-top: 1px dashed #EADFC6;
}
.gx-as__bottom-item {
  margin: 0;
  color: #606266;
  line-height: 1.6;
  flex: 1;
  min-width: 200px;
}
.gx-as__remark-line {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.gx-as__remark-k {
  color: #909399;
  flex-shrink: 0;
}
.gx-as__flag {
  font-style: normal;
}
.gx-as__remark-val {
  color: #303133;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.gx-as__remark-link {
  color: #409EFF;
  cursor: pointer;
  text-decoration: none;
  flex-shrink: 0;
  margin-left: 2px;
  transition: color .15s ease;
}
.gx-as__remark-link:hover {
  text-decoration: underline;
  color: #0E5DD8;
}
.gx-as__empty {
  text-align: center;
  padding: 60px 0;
  color: #909399;
  font-size: 13px;
}
.gx-as__empty::before {
  content: '📭';
  display: block;
  font-size: 36px;
  margin-bottom: 8px;
  opacity: .55;
}
.gx-as__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #EBEEF5;
  background: #FAF6EE;
  border-radius: 0 0 10px 10px;
  position: relative;
  z-index: 5;
}
.gx-as__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-as__pager-total {
  font-size: 12px;
  color: #666;
}
.gx-as__pager-btns {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-as__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #606266;
  transition: all .15s ease;
}
.gx-as__page:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-as__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-as__page--on {
  background: #C8443C;
  border-color: #C8443C;
  color: #FFFFFF;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.18);
}
.gx-as__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-as__modal--wide {
  z-index: 720;
}
.gx-as__modal-box {
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 94vh;
}
.gx-as__modal-box--xl {
  max-width: 1200px;
}
.gx-as__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  flex-shrink: 0;
  background: #FFFFFF;
}
.gx-as__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-as__modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  font-size: 14px;
}
.gx-as__modal-body {
  overflow-y: auto;
  background: #F4F6F8;
}
.gx-as__modal-body.bg-white{
  background: #ffffff;
  padding: 20px 24px 40px
}
.gx-as__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  flex-shrink: 0;
  align-items: center;
  background: #FFFFFF;
}
.gx-as__form {
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.gx-as__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gx-as__label {
  font-size: 13px;
  color: #1A1A2E;
  font-weight: 600;
}
.gx-as__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-as__input--sm {
  width: 90px;
}
.gx-as__dim {
  color: #6A6A8A;
  font-size: 12px;
}
.gx-as__tip {
  font-size: 12px;
  color: #F87171;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(250, 87, 87, .05);
  border: 1px solid rgba(250, 87, 87, .2);
}
.gx-as__radio {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #1A1A2E;
  user-select: none;
}
.gx-as__radio input[type='radio'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-as__radio-dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1.5px solid rgba(212, 169, 70, .35);
  background: #FFFFFF;
  position: relative;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-as__radio-dot::after {
  content: '';
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  transform: scale(0);
  transition: transform .15s;
}
.gx-as__radio--on .gx-as__radio-dot {
  border-color: #D4A946;
}
.gx-as__radio--on .gx-as__radio-dot::after {
  transform: scale(1);
}
</style>
